import type { NskResponse } from "~/models/Api";
import type { Notification, NotificationEdit } from "~/models/Notification";
import {
	deleteRequest,
	postRequest,
	putRequest
} from "~/utils/api/api_handler";

const paths = {
	create: "/company_notifications",
	destroy: "/company_notifications/:id",
	update: "/company_notifications/:id"
};

export const create = async (
	notification: NotificationEdit
): Promise<NskResponse> => postRequest(paths.create, { notification });

export const update = async (
	notification: NotificationEdit,
	notificationId: number
): Promise<NskResponse> =>
	putRequest(paths.update.replace(":id", String(notificationId)), {
		notification
	});

export const destroy = async (
	notification: Notification
): Promise<NskResponse> =>
	deleteRequest(paths.destroy.replace(":id", String(notification.id)));
